/* ==========================================================================
   Catalytic Converter Legality Checker
   Self-contained. Loaded only on this calculator's page.
   No shared dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pc-ccl]');
  if (!root) return;

  var CARB_STATES = { ca: 'California', ny: 'New York', co: 'Colorado', me: 'Maine' };
  /* Federal converters carry a five year or 50,000 mile emissions warranty,
     and CARB units carry their own. */
  var FED_WARRANTY = '5 years or 50,000 miles';

  /* ====================================================================
     compute(input) -> result

     PURE. No DOM, no network, no globals. All calculator logic lives here
     so it can be reasoned about and tested in isolation.
     ==================================================================== */
  function compute(input) {
    var year = isFinite(input.year) ? Math.round(input.year) : 2015;
    var isCarb = !!CARB_STATES[input.state];
    var stateName = CARB_STATES[input.state] || 'your state';
    var obd2 = input.obd2 || year >= 1996;

    var status, warnings = [], figures = [], rows = [];

    if (isCarb) {
      status = { key: 'now', label: 'CARB compliant required',
                 note: stateName + ' requires a CARB compliant converter with an EO number. A federal EPA converter will fail inspection.' };
      figures.push({ label: 'You need', value: 'CARB compliant',
        sub: 'Look for a CARB Executive Order number, written as EO D-XXX, stamped on the converter body.' });
    } else {
      status = { key: 'good', label: 'EPA compliant acceptable',
                 note: 'A federal EPA compliant converter is acceptable in ' + (input.state === 'other' ? 'most states' : stateName) + '. CARB units are also legal everywhere.' };
      figures.push({ label: 'You need', value: 'EPA compliant',
        sub: 'A federally compliant converter is the minimum. A CARB unit is legal in every state.' });
    }

    figures.push({ label: 'Vehicle', value: String(year) + (obd2 ? ', OBD-II' : ', pre-OBD-II'),
      sub: obd2 ? 'The onboard monitor watches converter efficiency and will set a P0420 or P0430 if it drops.'
                : 'No onboard catalyst monitor. Compliance is judged at the tailpipe.' });

    rows.push({ head: 'Requirement' });
    rows.push({ label: 'State', value: stateName });
    rows.push({ label: 'Standard', value: isCarb ? 'CARB' : 'EPA federal' });
    rows.push({ label: 'Look for', value: isCarb ? 'EO number stamped on the body' : 'EPA compliance marking' });
    rows.push({ label: 'Model year', value: String(year) });
    rows.push({ label: 'Emissions warranty', value: FED_WARRANTY });

    rows.push({ head: 'Before you buy' });
    rows.push({ label: 'Match', value: 'Converter must be specified for your exact year, engine and emissions family' });
    rows.push({ label: 'Keep', value: 'The receipt and the paperwork, inspectors ask for both' });
    rows.push({ label: 'Universal fit', value: isCarb ? 'Generally not acceptable in CARB states' : 'Acceptable if correctly sized and positioned' });

    if (input.reason === 'emissions') {
      warnings.push('A converter rarely fails on its own. It is usually killed by something upstream, such as a misfire, a leaking injector, an oil burning engine or a bad oxygen sensor. Fit a new converter without fixing that cause and the new one will fail too.');
      rows.push({ head: 'Find the cause first' });
      rows.push({ label: 'Check', value: 'Misfires, fuel trim, oxygen sensors' });
      rows.push({ label: 'Check', value: 'Oil or coolant consumption' });
      rows.push({ label: 'Check', value: 'Exhaust leaks upstream of the sensor' });
    }
    if (input.reason === 'performance') {
      warnings.push('Removing or defeating a catalytic converter on a road vehicle is a federal offence in the United States, and selling or installing a defeat device carries substantial penalties. High flow converters that retain compliance are the legal route.');
    }
    if (obd2 && isCarb) {
      warnings.push('Aftermarket converters sometimes trigger a P0420 on OBD-II vehicles even when correctly fitted, because the downstream sensor sees more activity than the strategy expects. Buying the grade specified for your emissions family reduces the risk.');
    }

    return { ok: true, errors: [], warnings: warnings, status: status, figures: figures, rows: rows };
  }

  /* ====================================================================
     Formatting
     ==================================================================== */
  function comma(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function num(n, dp) {
    if (!isFinite(n)) return '-';
    var v = Number(n).toFixed(dp == null ? 2 : dp);
    if (dp !== 0 && v.indexOf('.') > -1) v = v.replace(/\.?0+$/, '');
    var parts = v.split('.');
    return comma(parts[0]) + (parts[1] ? '.' + parts[1] : '');
  }

  function signed(n, dp) {
    if (!isFinite(n)) return '-';
    return (n > 0 ? '+' : '') + num(n, dp);
  }

  /* ====================================================================
     DOM wiring
     ==================================================================== */
  var FIELDS = [
      {
          "name": "state",
          "key": "s",
          "type": "select"
      },
      {
          "name": "year",
          "key": "y",
          "type": "number"
      },
      {
          "name": "reason",
          "key": "r",
          "type": "select"
      },
      {
          "name": "obd2",
          "key": "o",
          "type": "checkbox"
      }
  ];

  var els = {
    error:    root.querySelector('[data-r-error]'),
    status:   root.querySelector('[data-r-status]'),
    statusLbl:root.querySelector('[data-r-status-label]'),
    statusVal:root.querySelector('[data-r-status-value]'),
    statusNote:root.querySelector('[data-r-status-note]'),
    figures:  root.querySelector('[data-r-figures]'),
    rows:     root.querySelector('[data-r-rows]'),
    warnings: root.querySelector('[data-r-warnings]')
  };

  var STATUS_CLASSES = ['is-good','is-monitor','is-soon','is-now','is-critical'];

  function field(name) { return root.querySelector('[data-f="' + name + '"]'); }

  function readInput() {
    var o = {};
    FIELDS.forEach(function (f) {
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') o[f.name] = el.checked;
      else if (f.type === 'number') o[f.name] = parseFloat(el.value);
      else o[f.name] = el.value;
    });
    return o;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function renderFigures(figs) {
    els.figures.innerHTML = (figs || []).map(function (f) {
      return '<div class="pc-ccl__figure">'
        + '<div class="pc-ccl__figure-label">' + esc(f.label) + '</div>'
        + '<div class="pc-ccl__figure-value' + (f.muted ? ' is-muted' : '') + '">'
        + esc(f.value) + '</div>'
        + (f.sub ? '<div class="pc-ccl__figure-sub">' + esc(f.sub) + '</div>' : '')
        + '</div>';
    }).join('');
  }

  function renderRows(rows) {
    if (!els.rows) return;
    els.rows.innerHTML = (rows || []).map(function (r) {
      if (r.head) {
        return '<div class="pc-ccl__row pc-ccl__rows-head">' + esc(r.head) + '</div>';
      }
      return '<div class="pc-ccl__row">'
        + '<span class="pc-ccl__row-label">' + esc(r.label) + '</span>'
        + '<span class="pc-ccl__row-value">' + esc(r.value) + '</span>'
        + '</div>';
    }).join('');
  }

  function clearResult(message) {
    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      els.statusVal.textContent  = 'Waiting for your numbers';
      els.statusNote.textContent = message || '';
    }
    els.figures.innerHTML = '';
    if (els.rows) els.rows.innerHTML = '';
    if (els.warnings) els.warnings.style.display = 'none';
  }

  function render() {
    var input  = readInput();
    var result = compute(input);

    if (!result.ok) {
      els.error.textContent = result.errors[0];
      els.error.classList.add('is-shown');
      clearResult(result.errors[0]);
      return;
    }
    els.error.classList.remove('is-shown');

    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      if (result.status) {
        els.status.classList.add('is-' + result.status.key);
        els.statusVal.textContent  = result.status.label;
        els.statusNote.textContent = result.status.note || '';
      } else {
        els.statusVal.textContent  = '';
        els.statusNote.textContent = '';
      }
    }

    renderFigures(result.figures);
    renderRows(result.rows);

    if (els.warnings) {
      if (result.warnings && result.warnings.length) {
        els.warnings.textContent = result.warnings[0];
        els.warnings.style.display = '';
      } else {
        els.warnings.style.display = 'none';
      }
    }

    writePermalink(input);
  }

  /* ====================================================================
     Shareable result permalinks
     ==================================================================== */
  function writePermalink(input) {
    if (!window.history || !window.history.replaceState) return;
    var q = FIELDS.map(function (f) {
      var v = input[f.name];
      if (f.type === 'checkbox') return v ? f.key + '=1' : '';
      if (v == null || v !== v || v === '') return '';
      return f.key + '=' + encodeURIComponent(v);
    }).filter(Boolean).join('&');
    try {
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : ''));
    } catch (e) {}
  }

  function applyPermalink() {
    if (!window.URLSearchParams) return;
    var p = new URLSearchParams(window.location.search);
    var any = false;
    FIELDS.forEach(function (f) {
      if (!p.has(f.key)) return;
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') el.checked = p.get(f.key) === '1';
      else el.value = p.get(f.key);
      any = true;
    });
    return any;
  }

  /* ====================================================================
     Init
     ==================================================================== */
  ['input', 'change'].forEach(function (evt) {
    root.addEventListener(evt, function (e) {
      if (e.target.closest('[data-r-form]')) render();
    });
  });

  applyPermalink();
  render();

  /* Exposed for testing and debugging only. */
  window.PC_CCL = { compute: compute };
})();
